var map = {
	"./account-mascot.png": 35044,
	"./background1.png": 86588,
	"./en.png": 77848,
	"./es.png": 81156,
	"./icon_jivo.png": 77388,
	"./logo-sidebar.png": 99492,
	"./mobile/casino_menu_movil.png": 29584,
	"./mobile/casinolive_menu_movil.png": 4384,
	"./mobile/crash_menu_movil.png": 97668,
	"./mobile/sportslive_menu_movil.png": 9084,
	"./mobile/sportslive_movil.png": 87904,
	"./mobile/support_menu_movil.png": 83856,
	"./mobile/virtual_menu_movil.png": 25688,
	"./pt.png": 75584,
	"./telegram.png": 66184,
	"./whatsappBtn.png": 81856
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49092;